<div *ngIf="!fieldTemplate; else customTemplate" [id]="field.field + '_Item'" class="inputItem">
    <ng-container *ngIf="(inputFormControl?.statusChanges | async) || {}">
        <div class="datetime-input-wrapper">
            <mat-generic-mask-input class="datetime-time-input"
                    (keydown.shift.tab)="$event.preventDefault(); $event.stopImmediatePropagation()"
                    (keyup.shift.tab)="$event.preventDefault(); $event.stopImmediatePropagation();focusDate()"
                    [field]="timeField"
                    [inputFormControl]="formGroup.controls[field.field + '_time']">
                    <ng-template [matAddonField]="timeField">
                        <button mat-icon-button style="opacity: 0; pointer-events: none;"><mat-icon>close</mat-icon></button>
                    </ng-template>
            </mat-generic-mask-input>
            <mat-generic-date-input class="datetime-date-input"
                                    [field]="dateField"
                                    [inputFormControl]="formGroup.controls[field.field + '_date']"
                                    (keydown.tab)="$event.preventDefault(); $event.stopImmediatePropagation()"
                                    (keydown.enter)="$event.preventDefault(); $event.stopImmediatePropagation()"
                                    (keyup.tab)="$event.preventDefault(); $event.stopImmediatePropagation();focusTime()"
                                    (keyup.enter)="$event.preventDefault(); $event.stopImmediatePropagation();focusTime()">
                                  
            </mat-generic-date-input>
           
        </div>
        <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                          *ngIf="(inputFormControl?.statusChanges | async) === 'PENDING' || inputFormControl?.status === 'PENDING'"></mat-progress-bar>
    </ng-container>
</div>

<ng-template #customTemplate>
    <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: inputFormControl, index: index }"></ng-container>
</ng-template>
